import React, { Component } from 'react';
import Media from "react-media";
import { SCREEN_WIDTH } from '../../App.js';
import { translate } from 'react-i18next';
import Tag from '../../components/Tag/index.jsx';

class Rooms extends Component {


  renderRoom = (room) => {
    const { t } = this.props;

    return (
      <div
        className="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-6 card-panel-rooms card-link" 
        onClick={() => { this.props.handleRoomClick(room); }}
        key={room.id}
      > 
        <div className="card-panel panel panel-default card">
          <div className="panel-heading" style={{ backgroundImage: "url('" + room.picture + "')" }}>
          </div>
          <div className="card-panel-body">
            <div className="panel-body-title">
              <h4 className="iossala">{room.name}</h4>
            </div>
            <div className="panel-body-description">
              <div className="panel-description-text">
                {room.description}
              </div>
              <div className="panel-description-information">
                <div className="contenedor-flexbox">
                  <Tag
                      isBigTag
                      icon='people-group'
                      text={t("venta_linea.reservation_tags.capacity")}
                      value={`${room.capacity} personas`}
                  />
                </div>
                  {this.props.user.balance === undefined
                    && (
                      <div className="contenedor-flexbox">
                        <div className="contenedor">
                          <i className="fa fa-usd" aria-hidden="true"></i>
                          {t('dashboard.reservations.price') + " $" + room.price}
                        </div>
                      </div>
                    )
                  }
              </div>
            </div>
            <div className="panel-body-bottom">
              <div className="">
                <button
                  className="btn btn-block btn-primary"
                  type="button">
                  {t('dashboard.reservations.btn_book')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const rooms = this.props.rooms;
    return (
      <div className="list-card-resvations">
        <div className="list-card-panel-seccion">
          <div className="content-card-panel-seccion">
            <div className="list list2 grid-2">
              {rooms.map((room) => this.renderRoom(room))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Rooms);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/Rooms.js